import React from 'react';
import SattaPanel from '@/common-pages/satta/components/satta-panel';
import {useTranslation} from 'react-i18next';
import Won from '../won/won';

function getResultNum(
  openResultNum?: string | null,
  closeResultNum?: string | null,
) {
  let openNum, closeNum;
  if (openResultNum) {
    openNum = openResultNum.split('').reduce((s, y) => (s + +y) % 10, 0);
  } else {
    openNum = '*';
  }
  if (closeResultNum) {
    closeNum = closeResultNum.split('').reduce((s, y) => (s + +y) % 10, 0);
  } else {
    closeNum = '*';
  }
  return {openNum, closeNum};
}

interface SattaOrderDigitItem {
  digits: string;
  gameType: number;
  points: number;
  digitsWonAmount?: number;
  isWin?: number;
}

export interface MatkaProps {
  openNum: string;
  closeNum: string;
  userDigits: SattaOrderDigitItem[];
}

const Matka = ({userDigits = [], openNum = '', closeNum = ''}: MatkaProps) => {
  const {t} = useTranslation();
  const [showMore, setShowMore] = React.useState(false);
  const matkaType = [
    '',
    `${t('satta.betting.ank')} ${t('satta.betting.open')}`,
    `${t('satta.betting.ank')} ${t('satta.betting.close')}`,
    t('satta.betting.jodi'),
    `${t('satta.betting.sp')} ${t('satta.betting.open')}`,
    `${t('satta.betting.sp')} ${t('satta.betting.close')}`,
    `${t('satta.betting.dp')} ${t('satta.betting.open')}`,
    `${t('satta.betting.dp')} ${t('satta.betting.close')}`,
    `${t('satta.betting.tp')} ${t('satta.betting.open')}`,
    `${t('satta.betting.tp')} ${t('satta.betting.close')}`,
    `${t('satta.betting.half')} ${t('satta.betting.open')}`,
    `${t('satta.betting.half')} ${t('satta.betting.close')}`,
    t('satta.betting.full'),
  ];

  const pannelDigits = (open: string, close: string) => {
    return `${open || '***'}-${getResultNum(open, close).openNum}${
      getResultNum(open, close).closeNum
    }-${close || '***'}`;
  };

  const targetList = React.useMemo(() => {
    if (userDigits.length > 7 && showMore) {
      return userDigits;
    }
    return userDigits.slice(0, 7);
  }, [userDigits, showMore]);

  const winList = React.useMemo(() => {
    return userDigits.filter(
      item => item.digitsWonAmount && item.digitsWonAmount > 0,
    );
  }, [userDigits]);

  return (
    <div className="mt-2">
      <div className="flex items-center justify-between bg-[#F4F4F4] px-3 py-2">
        <div className="flex-1">
          <span className="text-sm font-bold">Drawn Results：</span>
        </div>
        <SattaPanel hideLabel pannel={pannelDigits(openNum, closeNum)} />
      </div>
      {winList.length > 0 && (
        <div>
          {winList.map((item, _i) => {
            return (
              <Won
                key={_i}
                awardAmount={item.digitsWonAmount!}
                bet={item.points}
                result={
                  <span className="text-sm font-bold text-[#F15802]">
                    {matkaType[item.gameType]}({item.digits})
                  </span>
                }
              />
            );
          })}
        </div>
      )}
      <div className="mt-2 flex gap-2">
        {targetList.map((item, _i) => {
          const isWin = item.digitsWonAmount && item.digitsWonAmount > 0;
          const showBtn = _i === 7 && !showMore;
          return showBtn ? (
            <button
              type="button"
              key={_i}
              className="flex h-9 items-center justify-center rounded-[1.125rem] border border-[#9FA5AC] bg-white px-4 font-bold"
              onClick={() => setShowMore(true)}>
              <span>View All</span>
            </button>
          ) : (
            <div
              key={_i}
              className={`flex h-9 items-center justify-center rounded-[1.125rem] px-4 font-bold ${
                isWin ? 'border border-[#F15802] bg-white' : 'bg-[#F6F7FB]'
              }`}>
              <span style={{color: isWin ? '#F15802' : '#48505D'}}>
                {matkaType[item.gameType]}({item.digits})
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Matka;
